import * as track from 'lib/gaTracking/bookingListPageEvents';
import * as crossPageTrack from 'lib/gaTracking/crossPageEvents';
import { CardProps } from '../types';
import { CardWrapper, CardImage, InfoWrapper, Heading, SubHeading, StayInfo, StayRating, Hr, ItemLinks } from '../Components';
import { getSurveyLink } from 'lib/links';
import { getStayRatingForBookingId } from 'lib/stayRating';
import { useBookingListContext } from 'pages/BookingListPage/contextProvider/BookingListContextProvider';

const PastBookingCard = ({ booking, index, ...rest }: CardProps) => {
  const { sendViewBookingEvent } = useBookingListContext();

  const {
    id,
    links,
    image,
    reservation: { property },
    flags: { isRateable },
  } = booking;

  const trackViewBookingEvent = () => sendViewBookingEvent(id);

  const detailsLink = {
    label: 'View details',
    url: links.manage,
    onClick: () => {
      track.viewDetailsLink(booking);
      trackViewBookingEvent();
    },
  };

  const rebookLink = {
    label: 'Book again',
    url: links.rebook,
    external: true,
    onClick: crossPageTrack.bookAgainLink,
    target: '_blank',
  };

  const reviewYourStayLink = {
    label: 'Review your stay',
    url: getSurveyLink(booking),
    external: true,
    onClick: crossPageTrack.reviewYourStayLink,
    target: '_blank',
  };

  const rating = getStayRatingForBookingId(id);
  const itemLinks = [detailsLink, rebookLink];

  if (isRateable && !rating) {
    itemLinks.push(reviewYourStayLink);
  }

  return (
    <CardWrapper>
      <CardImage {...image} link={detailsLink} onClick={trackViewBookingEvent} />
      <InfoWrapper bookingId={booking.id} {...rest}>
        <Heading>{property.name}</Heading>
        <SubHeading>{property.address.suburb}</SubHeading>

        <StayInfo booking={booking} />
        {isRateable && !rating && <StayRating booking={booking} />}
      </InfoWrapper>

      <Hr />

      <ItemLinks links={itemLinks} />
    </CardWrapper>
  );
};

PastBookingCard.displayName = 'PastBookingCard';

export { PastBookingCard };
